module.exports = __webpack_public_path__ + "static/media/entregarinju5.b974faa7.webp";